import { InputHTMLAttributes } from "react";

const Icomput = ({
  className,
  ...props
}: InputHTMLAttributes<HTMLInputElement>) => {
  return (
    <input
      className={`rounded-md border p-3 px-4 text-gray-900 focus:border-blue-500 focus-visible:border-blue-500 ${className}`}
      {...props}
    />
  );
};
//
export default Icomput;
